import React from 'react'

import { styled } from 'styled-components'

import { SingleLineWithEllipsis } from '@b-stock/fe-core/bstock-next/components'

const List = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 100%;
  white-space: nowrap;
  flex-wrap: nowrap;
  & > div {
    flex-shrink: 1;
    &:first-child {
      flex-shrink: 0;
    }
  }
`

const DefaultDivider = styled.span`
  height: 0.5rem;
  width: 0.0625rem;
  background: currentcolor;
`

type DividerListEntry = {
  key: string
  node: React.ReactNode | null
}

const DividerSeparatedList = ({
  values,
  Divider = DefaultDivider,
  className,
}: {
  values: DividerListEntry[]
  Divider?: typeof DefaultDivider
  className?: string
}) => {
  const definedValues = values.filter(({ node }) => !!node)

  return (
    <List className={className}>
      {definedValues.map(({ key, node }, index) =>
        node ? (
          <React.Fragment key={key}>
            {index > 0 ? <Divider /> : null}
            <SingleLineWithEllipsis key={key} data-testid={key}>
              {node}
            </SingleLineWithEllipsis>
          </React.Fragment>
        ) : null
      )}
    </List>
  )
}

export default DividerSeparatedList
